import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ColDef,
  DomLayoutType,
  ProcessCellForExportParams,
  SideBarDef,
} from '@ag-grid-community/core';
import { ExcelStyle, GridOptions, RowModelType } from 'ag-grid-community';
import { CustomGridDateFilterComponent } from '../custom-grid-date-filter.component';

@Component({
  selector: 'app-grid-container',
  templateUrl: './grid-container.component.html',
  styleUrls: ['./grid-container.component.scss'],
})
export class GridContainerComponent {
  @Input() gridRowData: any[];
  @Input() name: string;
  @Input() description: string;
  @Input() fontWeight: string;

  private _components: any = {
    // agDateInput: CustomDateComponent,
    agDateInput: CustomGridDateFilterComponent,
  };

  get components() {
    return this._components;
  }

  @Input() set components(obj: any) {
    this._components = { ...obj, ...this._components };
  }
  @Input() processCellForClipboardExternalFunction?: any;
  @Input() defaultExcelExportParams: any;
  @Input() gridColDefs: ColDef[];
  @Input() excelStyles: ExcelStyle[];
  @Input() gridDefaultColDef: ColDef;
  @Input() gridOptions?: GridOptions<any> | undefined;
  @Input() hasPagination = false;
  @Input() gridPaginationPageSize = 100;
  @Input() sideBar: SideBarDef | string | string[] | boolean | null;
  @Input() domLayout: DomLayoutType;
  @Input() hasMasterDetail = true;
  @Input() keepDetailRows = true;
  @Input() keepDetailRowsCount = 2;
  @Input() detailCellRendererParams: any;
  @Input() rowHeight = 20;
  @Input() isGridDraggable: boolean;
  @Input() editType: 'fullRow';
  @Input() rowModelType: RowModelType = 'clientSide';
  @Input() rowSelection: 'multiple' | 'single' = 'multiple';
  @Input() isSuppressMoveWhenRowDragging: boolean;
  @Input() classNames: string;
  @Input() isPinnedRowHide = false;
  @Input() copyGroupHeadersToClipboard = true;
  @Output() gridReady = new EventEmitter<any>();
  @Output() filterChanged = new EventEmitter<any>();
  @Output() sortChanged = new EventEmitter<any>();
  @Output() rowClicked = new EventEmitter<any>();
  @Output() cellClicked = new EventEmitter<any>();
  @Output() cellDoubleClicked = new EventEmitter<any>();
  @Output() cellValueChanged = new EventEmitter<any>();
  @Output() rowValueChanged = new EventEmitter<any>();
  @Output() rowDragEnd = new EventEmitter<any>();
  @Output() rowDragEnter = new EventEmitter<any>();
  @Output() rowDragMove = new EventEmitter<any>();
  @Output() columnVisible = new EventEmitter<any>();
  @Output() rowDoubleClicked = new EventEmitter<any>();
  @Output() rowSelected = new EventEmitter<any>();
  @Output() selectionChanged = new EventEmitter<any>();
  @Output() rowGroupOpened = new EventEmitter<any>();
  @Output() cellEditingStarted = new EventEmitter<any>();
  @Output() cellEditingStopped = new EventEmitter<any>();
  getContextMenuItems = (params: any) => {
    if (this.isPinnedRowHide && params.node.rowPinned === 'bottom') {
      return [];
    }
    return ['copy', 'copyWithHeaders'];
  };
  @Input() getRowId = (params: any) => params.data.id;

  processCellForClipboard:
    | ((params: ProcessCellForExportParams<any>) => any)
    | undefined = (params) => {
    if (typeof params.value === 'string') {
      return params.value?.replace(/\n/g, '').replace(/\s+/g, ' ').trim();
    } else {
      return params.value;
    }
  };
}
